import { apiCall } from '../apiServerHelper'
import { apis } from '../apiUrls'

export const reportIssue = data => {
  return apiCall(apis.REPORT_ISSUE, data, 'POST', false)
}
